import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import { post } from "../../../redux/modules/session/actions";
import { WithStyles, withStyles } from '@mui/styles';
import APHeading from "../../atoms/APHeading";
import APButton from "../../atoms/APButton";
import { withNavigation, withTenant, withTranslate } from "../../../core/TenantProvider";
import DocumentsUploadContainerStyles from "./styles/DocumentsUploadContainer.style";
import { actions as SlidingRightPanelActions } from '../../../redux/modules/uistates';
import { actions as RegisterActions } from '../../../redux/modules/register';
import APExpandingPanelsSection from "../APExpandingPanelsSection/APExpandingPanelsSection";
import { ReducerState } from "../../../redux/modules";
import APBackdropLoader from "../../atoms/APBackdropLoader";
import { actions as servicesDowntimeAction } from '../../../redux/modules/servicesDowntime';
import { APRegistrationSuccess } from "../APRegistrationSuccess";
import { TriggerGoogleAnalytics4Tag } from '../../../core/utils/GoogleAnalyticTag';
import { GoogleAnalytics4Tags } from '../../../core/utils/GoogleAnalyticTag/GoogleAnalytics4Tags';


interface DocumentsUploadContainerProps extends WithStyles<typeof DocumentsUploadContainerStyles> {
    translate: Function,
    postDocument: Function,
    updateRegisterCustomerStatus: Function,
    sendSkipDocumentEmail: Function,
    toggleSlidingRightPanelStatus: Function,
    customer_state: any,
    affiliateDetails: any,
    navigate: any,
    isJointAccReg?: boolean,
    singleAccDocuments: any,
    jointAccDocuments?: any,
    loadingState?: string,
    getServicesErrorObj: Function,
    primaryContactStatus?: string,
    secondaryContactStatus?: string
}

interface DocumentsUploadContainerState {
    single: any,
    joint: any,
    showComplete: boolean,
    isSingleComplete: boolean,
    showReferralMessage: boolean,
}

interface POIAndPOAType {
    POI: string,
    POA: string,
}

class DocumentsUploadContainer extends Component<DocumentsUploadContainerProps, DocumentsUploadContainerState> {
    constructor(props) {
        super(props);

        this.state = {
            single: {
                poi: 0,
                poa: 0
            },
            joint: {
                poi: 0,
                poa: 0
            },
            showComplete: false,
            isSingleComplete: props.primaryContactStatus === 'ACTIVE' && props.secondaryContactStatus === 'INACTIVE',
            showReferralMessage: false,
        };

        this.onReturn = this.onReturn.bind(this);
        this.handleDocumentUpload = this.handleDocumentUpload.bind(this);
        this.handleGAEvents = this.handleGAEvents.bind(this);
        this.gaEvents = this.gaEvents.bind(this)
    }

    gaEvents = (event: string, variant?: string) => {
        const eventVariant = variant === 'load' ? GoogleAnalytics4Tags.eventAction.load : GoogleAnalytics4Tags.eventAction.click
        TriggerGoogleAnalytics4Tag(
            GoogleAnalytics4Tags.registerClient.name,
            eventVariant,
            event
        );
    }

    handleGAEvents = (variant: string) => {
        if (this.props.singleAccDocuments && this.props.singleAccDocuments.length === 2) {
            const getEventType: string = variant === 'load' ? GoogleAnalytics4Tags.registerClient.load.poiPoaPageLoad :
                GoogleAnalytics4Tags.registerClient.click.poiPoaSkipThisStep

            this.gaEvents(getEventType)
        } else {
            const getLoadEvent: POIAndPOAType = {
                'POI': variant === 'load' ? GoogleAnalytics4Tags.registerClient.load.poiPageLoad : GoogleAnalytics4Tags.registerClient.click.poiSkipThisStep,
                'POA': variant === 'load' ? GoogleAnalytics4Tags.registerClient.load.poaPageLoad : GoogleAnalytics4Tags.registerClient.click.poaSkipThisStep
            }

            if (this.props.singleAccDocuments) {
                const getType: string = getLoadEvent[this.props.singleAccDocuments[0].type];
                this.gaEvents(getType, variant)
            }

        }
    }

    componentDidMount() {
        this.handleGAEvents('load')
    }

    onReturn() {
        this.props.navigate.push('/register_client');
        this.props.updateRegisterCustomerStatus();
    }

    handleDocumentUpload(accountType: string, documentType: string, documentCount: number) {

        let currentDocState = {};
        currentDocState[accountType.toLowerCase()] = this.state[accountType.toLowerCase()];
        currentDocState[accountType.toLowerCase()][documentType.toLowerCase()] = documentCount;

        this.setState({
            ...currentDocState
        }, () => {
            console.log('State after document upload: ', this.state);
        });
    }

    render() {
        const {
            classes,
            translate,
            postDocument,
            toggleSlidingRightPanelStatus,
            affiliateDetails,
            isJointAccReg,
            singleAccDocuments,
            jointAccDocuments,
            loadingState
        } = this.props;

        let isSingleAccFormValid = true;
        let isJointAccFormValid = true;

        let expandingPanelsView = (
            <>
                {singleAccDocuments && singleAccDocuments.map((currentDoc, index) => {

                    isSingleAccFormValid && (isSingleAccFormValid = this.state.single[currentDoc.type.toLowerCase()] > 0);

                    return <APExpandingPanelsSection
                        singleAccDocuments={singleAccDocuments}
                        type={currentDoc.type}
                        uploadURL={currentDoc.upload_url}
                        uploadDocument={postDocument}
                        toggleSlidingRightPanelStatus={toggleSlidingRightPanelStatus}
                        handleDocumentUpload={this.handleDocumentUpload}
                        accountType="SINGLE"
                        key={`SINGLE-${currentDoc.type}`}

                        hideContinueButtonSingle={singleAccDocuments.length > 1}
                        hideContinueButtonBoth={index !== 1}
                        hideSkipLink={index === 0}
                        singleParagraph={true}
                        hideHeader={index === 1}

                        isJointAccReg={isJointAccReg}
                        jointAccDocuments={jointAccDocuments}
                    />
                })}
            </>
        );

        const showJointDocUploadView = (
            <>
                {jointAccDocuments && jointAccDocuments.map((currentDoc, index) => {
                    isJointAccFormValid && (isJointAccFormValid = this.state.joint[currentDoc.type.toLowerCase()] > 0);

                    return (
                        <APExpandingPanelsSection
                            singleAccDocuments={singleAccDocuments}
                            type={currentDoc.type}
                            uploadURL={currentDoc.upload_url}
                            uploadDocument={postDocument}
                            toggleSlidingRightPanelStatus={toggleSlidingRightPanelStatus}
                            handleDocumentUpload={this.handleDocumentUpload}
                            accountType="JOINT"
                            key={`JOINT-${currentDoc.type}`}

                            hideContinueButtonSingle={jointAccDocuments.length > 1}
                            hideContinueButtonBoth={index !== 1}
                            hideSkipLink={index === 0}
                            singleParagraph={true}
                            hideHeader={index === 1}

                            isJointAccReg={isJointAccReg}
                            jointAccDocuments={jointAccDocuments}
                        />
                    )
                })}
            </>
        );

        const {
            showComplete,
            showReferralMessage,
            isSingleComplete,
        } = this.state;

        const showCompleteView = (
            <div className={classes.completeViewContainer}>
                <div className={classes.formHeader}>
                    <APHeading variant="h4">
                        {translate('register.customer.title')}
                    </APHeading>
                </div>
                <div className={classes.viewContainer}>
                    <APRegistrationSuccess
                        showReferralMessage={showReferralMessage}
                    />
                </div>
            </div>);

        let currentView: any = '';
        if (showComplete) {
            currentView = showCompleteView;
        } else if (isSingleComplete) {
            currentView = showJointDocUploadView;
        } else {
            currentView = expandingPanelsView;
        }

        return (
            <div className={classes.docUploadContainer}>
                <div className={classes.docUploadInnerSection}>
                    {loadingState === 'LOADING' && <APBackdropLoader open={true} />}
                    {showComplete ? '' :
                        <div className={classes.docUploadHeader}>
                            <APHeading className={classes.docUploadSectionHeading} variant="h4">
                                {translate('register.customer.identity.title')} {(isJointAccReg && isSingleComplete) ? ' - Joint Account' : ''}
                            </APHeading>
                            <APButton className={[classes.skipLink].join(' ')}
                                onClick={() => {
                                    this.handleGAEvents('click')

                                    // TODO Proper code - remove above hardcoding
                                    const {
                                        customer_state,
                                        getServicesErrorObj
                                    } = this.props;

                                    this.props.sendSkipDocumentEmail(customer_state, affiliateDetails?.affiliate?.owner_emailid)
                                        .then((response) => {
                                            console.log('Response: ', response);
                                            this.setState({
                                                showComplete: !this.state.showComplete,
                                                showReferralMessage: !this.state.showReferralMessage
                                            });
                                        }).catch((error) => {
                                            console.log('Error: ', error);
                                            getServicesErrorObj(error);
                                        });
                                }}>
                                {translate("poi.skip.link")}
                            </APButton>
                        </div>}
                    <div className={classes.docUploaderContainer}>
                        {currentView}
                    </div>
                    {showComplete ? '' :
                        <div className={classes.formButtons}>
                            <div className={classes.formButtonsLeft}></div>
                            <div className={classes.formButtonsRight}>
                                <div className={classes.centreButtons}>
                                    <APButton
                                        children={'Continue'}
                                        className={classes.formButton}
                                        color="primary"
                                        disabled={isSingleComplete ? !isJointAccFormValid : !isSingleAccFormValid}
                                        variant="contained"
                                        onClick={() => {
                                            if (isJointAccReg) {
                                                if (this.state.isSingleComplete) {
                                                    this.setState({
                                                        showComplete: !this.state.showComplete
                                                    });
                                                } else {
                                                    this.setState({
                                                        isSingleComplete: true,
                                                        showComplete: jointAccDocuments?.length <= 0
                                                    });
                                                }
                                            } else {
                                                this.setState({
                                                    showComplete: !this.state.showComplete
                                                });
                                            }
                                        }} />
                                </div>
                            </div>
                        </div>}
                </div>
            </div>
        );
    }
}

const mapStateToProps = (store: ReducerState) => ({
    customer_state: store.register.customer_state,
    affiliateDetails: store.user.affiliateDetails,
    loadingState: store.register.loadingState,
});

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators({
    postDocument: post,
    toggleSlidingRightPanelStatus: SlidingRightPanelActions.toggleSlidingRightPanelStatus,
    updateRegisterCustomerStatus: RegisterActions.updateRegisterCustomerStatus,
    sendSkipDocumentEmail: RegisterActions.sendSkipDocumentEmail,
    getServicesErrorObj: servicesDowntimeAction.getServicesErrorObj
}, dispatch);

export default
withNavigation(
        withTenant(
            withTranslate(
                withStyles(DocumentsUploadContainerStyles)(
                    connect(mapStateToProps, mapDispatchToProps)(DocumentsUploadContainer)
                )
            )
        )
    );